import { FeatureFlag } from './flags';
import { FeatureFlagService } from './types';

/**
 * Service for retrieving feature flag values from URL parameters.
 */
class URLParamFeatureFlagService implements FeatureFlagService {
  params: URLSearchParams;
  constructor(params: URLSearchParams) {
    this.params = params;
  }

  /**
   * Retrieves the value of a feature flag from the URL parameters.
   * To set a feature flag, add a query parameter to the URL with the flag name and a value of 'true'.
   * @param flag - The feature flag to retrieve.
   * @returns The value of the feature flag (true or false), or null if the flag is not present in the URL parameters.
   */
  getFeatureFlagValue(flag: FeatureFlag) {
    if (!this.params.has(flag)) {
      return null; // No param present in URL
    }
    return this.params.get(flag) === 'true';
  }
}

export default URLParamFeatureFlagService;
